import { View, type ViewProps, type StyleProp, type ViewStyle } from 'react-native';

import { colors, radius, shadows } from '@/theme/tokens';

interface Props extends ViewProps {
  variant?: 'plain' | 'soft' | 'elevated' | 'outlined' | 'gradient';
  padding?: number;
  style?: StyleProp<ViewStyle>;
}

export function Card({ children, variant = 'elevated', padding = 20, style, ...rest }: Props) {
  return (
    <View
      style={[
        {
          backgroundColor: variant === 'soft' ? colors.crema[50] : colors.white,
          borderRadius: radius['3xl'],
          padding,
          borderWidth: variant === 'outlined' ? 1 : 0,
          borderColor: colors.ink[200],
        },
        variant === 'elevated' ? shadows.card : null,
        style,
      ]}
      {...rest}
    >
      {children}
    </View>
  );
}
